<app-header></app-header>

<div class="inside">
  <div class="row">
    <div class="col-sm">
      <h4 class="height">Montag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket closed' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Dienstag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket in progress' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Mittwoch</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket accepted' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Donnerstag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItemsByLikes">
          <div *ngIf="item.status === 'Ticket open' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <div class="middle" matBadge="{{ item.likers ? item.likers.length : 0 }}" matBadgeOverlap="true"></div>
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Freitag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket declined' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Samstag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket declined' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
    <div class="col-sm">
      <h4 class="height">Sonntag</h4>
      <ul class="col-sm-12  offset-sm-12">
        <div *ngFor="let item of orderedItems">
          <div *ngIf="item.status === 'Ticket declined' && (item.createdBy === user.email || item.respmail === user.email)">
            <mat-card class="example-card" (click)="openDialog(item)">
              <mat-card-header>
                <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                <mat-card-subtitle class="insideText">{{ item.subject }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </ul>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
